import type { EtatContrat } from '@artosera/shared';
import { estApiError } from '../../api/errors.js';
export const TON_ETAT = {
  genere: 'neutral',
  signe: 'accent',
  annule: 'neutral',
} as const satisfies Record<EtatContrat, string>;
export function dateContrat(v: string, langue: string): string {
  return new Intl.DateTimeFormat(langue, { dateStyle: 'medium', timeZone: 'UTC' }).format(
    new Date(v),
  );
}
export function erreurContrat(e: unknown, defaut: string): string {
  if (!estApiError(e)) return defaut;
  const d = e.details;
  return (
    e.message +
    (typeof d === 'object' && d !== null && 'champs' in d && Array.isArray(d.champs)
      ? ` (${d.champs.join(', ')})`
      : '')
  );
}
